/**
 * HelpTooltip Component
 *
 * Small "?" button that reveals explanatory tooltip text on click.
 * Used next to step headers and individual fields for contextual help.
 */

import React, { useState } from "react";

export interface HelpTooltipProps {
  /** Tooltip content text */
  content: string;
  /** Accessible label for the trigger button */
  ariaLabel: string;
}

/**
 * HelpTooltip — Toggle-based help tooltip
 *
 * Renders a "?" trigger button. When clicked, displays a tooltip bubble
 * with explanatory content. Clicking again dismisses the tooltip.
 */
export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  content,
  ariaLabel,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="help-tooltip-wrapper">
      <button
        className="onboarding-help-trigger"
        aria-label={ariaLabel}
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        ?
      </button>
      {isOpen && (
        <div className="help-tooltip-bubble" role="tooltip">
          <p>{content}</p>
        </div>
      )}
    </div>
  );
};

export default HelpTooltip;
